var map = {
	"./v283/shifting_content_after.png": [
		"./code/client/static/images/patch_notes/v283/shifting_content_after.png",
		"shared"
	],
	"./v283/shifting_content_before.png": [
		"./code/client/static/images/patch_notes/v283/shifting_content_before.png",
		"shared"
	],
	"./v283/shuffle_card_after.png": [
		"./code/client/static/images/patch_notes/v283/shuffle_card_after.png",
		"shared"
	],
	"./v283/shuffle_card_before.png": [
		"./code/client/static/images/patch_notes/v283/shuffle_card_before.png",
		"shared"
	],
	"./v283/stop-achievements-blocking-after.png": [
		"./code/client/static/images/patch_notes/v283/stop-achievements-blocking-after.png",
		"shared"
	],
	"./v283/stop-achievements-blocking-before.png": [
		"./code/client/static/images/patch_notes/v283/stop-achievements-blocking-before.png",
		"shared"
	],
	"./v284/android_status_bar_after.png": [
		"./code/client/static/images/patch_notes/v284/android_status_bar_after.png",
		"shared"
	],
	"./v284/android_status_bar_before.png": [
		"./code/client/static/images/patch_notes/v284/android_status_bar_before.png",
		"shared"
	],
	"./v284/city_improvement_mobile_after.png": [
		"./code/client/static/images/patch_notes/v284/city_improvement_mobile_after.png",
		"shared"
	],
	"./v284/city_improvement_mobile_before.png": [
		"./code/client/static/images/patch_notes/v284/city_improvement_mobile_before.png",
		"shared"
	],
	"./v284/counter_offer_8p_after.png": [
		"./code/client/static/images/patch_notes/v284/counter_offer_8p_after.png",
		"shared"
	],
	"./v284/counter_offer_8p_before.png": [
		"./code/client/static/images/patch_notes/v284/counter_offer_8p_before.png",
		"shared"
	],
	"./v284/trade_counter_offer_after.png": [
		"./code/client/static/images/patch_notes/v284/trade_counter_offer_after.png",
		"shared"
	],
	"./v284/trade_counter_offer_before.png": [
		"./code/client/static/images/patch_notes/v284/trade_counter_offer_before.png",
		"shared"
	],
	"./v286/bot_kick_confirmation_before.png": [
		"./code/client/static/images/patch_notes/v286/bot_kick_confirmation_before.png",
		"shared"
	],
	"./v286/room_guests_after.png": [
		"./code/client/static/images/patch_notes/v286/room_guests_after.png",
		"shared"
	],
	"./v286/room_guests_before.png": [
		"./code/client/static/images/patch_notes/v286/room_guests_before.png",
		"shared"
	],
	"./v287/ios_dice_resolution_after.png": [
		"./code/client/static/images/patch_notes/v287/ios_dice_resolution_after.png",
		"shared"
	],
	"./v287/ios_dice_resolution_before.png": [
		"./code/client/static/images/patch_notes/v287/ios_dice_resolution_before.png",
		"shared"
	],
	"./v287/mobile_endgame_after.png": [
		"./code/client/static/images/patch_notes/v287/mobile_endgame_after.png",
		"shared"
	],
	"./v287/mobile_endgame_before.png": [
		"./code/client/static/images/patch_notes/v287/mobile_endgame_before.png",
		"shared"
	],
	"./v288/new_badge_after.png": [
		"./code/client/static/images/patch_notes/v288/new_badge_after.png",
		"shared"
	],
	"./v288/new_badge_before.png": [
		"./code/client/static/images/patch_notes/v288/new_badge_before.png",
		"shared"
	],
	"./v289/fix_pixelated_fullscreen_popup_after.png": [
		"./code/client/static/images/patch_notes/v289/fix_pixelated_fullscreen_popup_after.png",
		"shared"
	],
	"./v289/fix_pixelated_fullscreen_popup_before.png": [
		"./code/client/static/images/patch_notes/v289/fix_pixelated_fullscreen_popup_before.png",
		"shared"
	],
	"./v289/group_owned_maps_after.png": [
		"./code/client/static/images/patch_notes/v289/group_owned_maps_after.png",
		"shared"
	],
	"./v289/group_owned_maps_before.png": [
		"./code/client/static/images/patch_notes/v289/group_owned_maps_before.png",
		"shared"
	],
	"./v289/message_appears_without_username_avatar_after.png": [
		"./code/client/static/images/patch_notes/v289/message_appears_without_username_avatar_after.png",
		"shared"
	],
	"./v289/message_appears_without_username_avatar_before.png": [
		"./code/client/static/images/patch_notes/v289/message_appears_without_username_avatar_before.png",
		"shared"
	],
	"./v289/rename_lobby_to_room_after.png": [
		"./code/client/static/images/patch_notes/v289/rename_lobby_to_room_after.png",
		"shared"
	],
	"./v289/rename_lobby_to_room_before.png": [
		"./code/client/static/images/patch_notes/v289/rename_lobby_to_room_before.png",
		"shared"
	],
	"./v289/update_payment_successful_popup_after.png": [
		"./code/client/static/images/patch_notes/v289/update_payment_successful_popup_after.png",
		"shared"
	],
	"./v289/update_payment_successful_popup_before.png": [
		"./code/client/static/images/patch_notes/v289/update_payment_successful_popup_before.png",
		"shared"
	],
	"./v292/portrait_new_top_bar_after.png": [
		"./code/client/static/images/patch_notes/v292/portrait_new_top_bar_after.png",
		"shared"
	],
	"./v292/portrait_new_top_bar_before.png": [
		"./code/client/static/images/patch_notes/v292/portrait_new_top_bar_before.png",
		"shared"
	],
	"./v293/new_leaderboard_icon_after.png": [
		"./code/client/static/images/patch_notes/v293/new_leaderboard_icon_after.png",
		"shared"
	],
	"./v293/new_leaderboard_icon_before.png": [
		"./code/client/static/images/patch_notes/v293/new_leaderboard_icon_before.png",
		"shared"
	],
	"./v293/page_scrolling_after.png": [
		"./code/client/static/images/patch_notes/v293/page_scrolling_after.png",
		"shared"
	],
	"./v293/page_scrolling_before.png": [
		"./code/client/static/images/patch_notes/v293/page_scrolling_before.png",
		"shared"
	],
	"./v294/new_homepage_cards_after.png": [
		"./code/client/static/images/patch_notes/v294/new_homepage_cards_after.png",
		"shared"
	],
	"./v294/new_homepage_cards_before.png": [
		"./code/client/static/images/patch_notes/v294/new_homepage_cards_before.png",
		"shared"
	],
	"./v295/checkout_button_after.png": [
		"./code/client/static/images/patch_notes/v295/checkout_button_after.png",
		"shared"
	],
	"./v295/checkout_button_before.png": [
		"./code/client/static/images/patch_notes/v295/checkout_button_before.png",
		"shared"
	],
	"./v295/new_game_mode_icons_after.gif": [
		"./code/client/static/images/patch_notes/v295/new_game_mode_icons_after.gif",
		"shared"
	],
	"./v295/new_game_mode_icons_before.gif": [
		"./code/client/static/images/patch_notes/v295/new_game_mode_icons_before.gif",
		"shared"
	],
	"./v295/portrait-player-info-before.png": [
		"./code/client/static/images/patch_notes/v295/portrait-player-info-before.png",
		"shared"
	],
	"./v295/portrait-player-info-new.gif": [
		"./code/client/static/images/patch_notes/v295/portrait-player-info-new.gif",
		"shared"
	],
	"./v295/portrait-player-info-new.png": [
		"./code/client/static/images/patch_notes/v295/portrait-player-info-new.png",
		"shared"
	],
	"./v295/store_popup_tablet_after.png": [
		"./code/client/static/images/patch_notes/v295/store_popup_tablet_after.png",
		"shared"
	],
	"./v295/store_popup_tablet_before.png": [
		"./code/client/static/images/patch_notes/v295/store_popup_tablet_before.png",
		"shared"
	],
	"./v296/1v1-new.png": [
		"./code/client/static/images/patch_notes/v296/1v1-new.png",
		"shared"
	],
	"./v296/1v1-old.png": [
		"./code/client/static/images/patch_notes/v296/1v1-old.png",
		"shared"
	],
	"./v296/new-menu-icons-after.png": [
		"./code/client/static/images/patch_notes/v296/new-menu-icons-after.png",
		"shared"
	],
	"./v296/new-menu-icons-before.png": [
		"./code/client/static/images/patch_notes/v296/new-menu-icons-before.png",
		"shared"
	],
	"./v296/tablet-layout-new.png": [
		"./code/client/static/images/patch_notes/v296/tablet-layout-new.png",
		"shared"
	],
	"./v296/tablet-layout-old.png": [
		"./code/client/static/images/patch_notes/v296/tablet-layout-old.png",
		"shared"
	],
	"./v296/toast-vertical-align-after.png": [
		"./code/client/static/images/patch_notes/v296/toast-vertical-align-after.png",
		"shared"
	],
	"./v296/toast-vertical-align-before.png": [
		"./code/client/static/images/patch_notes/v296/toast-vertical-align-before.png",
		"shared"
	],
	"./v297/chat-dice-overlap-after.png": [
		"./code/client/static/images/patch_notes/v297/chat-dice-overlap-after.png",
		"shared"
	],
	"./v297/chat-dice-overlap-before.png": [
		"./code/client/static/images/patch_notes/v297/chat-dice-overlap-before.png",
		"shared"
	],
	"./v297/fix-hover-after.png": [
		"./code/client/static/images/patch_notes/v297/fix-hover-after.png",
		"shared"
	],
	"./v297/fix-hover-before.png": [
		"./code/client/static/images/patch_notes/v297/fix-hover-before.png",
		"shared"
	],
	"./v297/fix-pencil-icon-after.png": [
		"./code/client/static/images/patch_notes/v297/fix-pencil-icon-after.png",
		"shared"
	],
	"./v297/fix-pencil-icon-before.png": [
		"./code/client/static/images/patch_notes/v297/fix-pencil-icon-before.png",
		"shared"
	],
	"./v297/more-page-after.png": [
		"./code/client/static/images/patch_notes/v297/more-page-after.png",
		"shared"
	],
	"./v297/more-page-before.png": [
		"./code/client/static/images/patch_notes/v297/more-page-before.png",
		"shared"
	],
	"./v297/move-profile-page-after.png": [
		"./code/client/static/images/patch_notes/v297/move-profile-page-after.png",
		"shared"
	],
	"./v297/move-profile-page-before.png": [
		"./code/client/static/images/patch_notes/v297/move-profile-page-before.png",
		"shared"
	],
	"./v298/2-3p-mobile-ui-after.png": [
		"./code/client/static/images/patch_notes/v298/2-3p-mobile-ui-after.png",
		"shared"
	],
	"./v298/2-3p-mobile-ui-before.png": [
		"./code/client/static/images/patch_notes/v298/2-3p-mobile-ui-before.png",
		"shared"
	],
	"./v298/endgame-flag-after.png": [
		"./code/client/static/images/patch_notes/v298/endgame-flag-after.png",
		"shared"
	],
	"./v298/endgame-flag-before.png": [
		"./code/client/static/images/patch_notes/v298/endgame-flag-before.png",
		"shared"
	],
	"./v298/game-mode-reorder-after.png": [
		"./code/client/static/images/patch_notes/v298/game-mode-reorder-after.png",
		"shared"
	],
	"./v298/game-mode-reorder-before.png": [
		"./code/client/static/images/patch_notes/v298/game-mode-reorder-before.png",
		"shared"
	],
	"./v298/login-redesign-after.png": [
		"./code/client/static/images/patch_notes/v298/login-redesign-after.png",
		"shared"
	],
	"./v298/login-redesign-before.png": [
		"./code/client/static/images/patch_notes/v298/login-redesign-before.png",
		"shared"
	],
	"./v298/mobile-login-after.png": [
		"./code/client/static/images/patch_notes/v298/mobile-login-after.png",
		"shared"
	],
	"./v298/mobile-login-before.png": [
		"./code/client/static/images/patch_notes/v298/mobile-login-before.png",
		"shared"
	],
	"./v298/web-login-popup-after.png": [
		"./code/client/static/images/patch_notes/v298/web-login-popup-after.png",
		"shared"
	],
	"./v298/web-login-popup-before.png": [
		"./code/client/static/images/patch_notes/v298/web-login-popup-before.png",
		"shared"
	],
	"./v299/card-container-transparency-after.png": [
		"./code/client/static/images/patch_notes/v299/card-container-transparency-after.png",
		"shared"
	],
	"./v299/card-container-transparency-before.png": [
		"./code/client/static/images/patch_notes/v299/card-container-transparency-before.png",
		"shared"
	],
	"./v299/chits-icon-after.png": [
		"./code/client/static/images/patch_notes/v299/chits-icon-after.png",
		"shared"
	],
	"./v299/chits-icon-before.png": [
		"./code/client/static/images/patch_notes/v299/chits-icon-before.png",
		"shared"
	],
	"./v299/floating-text-pill-style-after.png": [
		"./code/client/static/images/patch_notes/v299/floating-text-pill-style-after.png",
		"shared"
	],
	"./v299/floating-text-pill-style-before.png": [
		"./code/client/static/images/patch_notes/v299/floating-text-pill-style-before.png",
		"shared"
	],
	"./v299/ios-context-menu-before.png": [
		"./code/client/static/images/patch_notes/v299/ios-context-menu-before.png",
		"shared"
	],
	"./v299/profile-page-after.png": [
		"./code/client/static/images/patch_notes/v299/profile-page-after.png",
		"shared"
	],
	"./v299/profile-page-before.png": [
		"./code/client/static/images/patch_notes/v299/profile-page-before.png",
		"shared"
	],
	"./v299/tab-slide-after.gif": [
		"./code/client/static/images/patch_notes/v299/tab-slide-after.gif",
		"shared"
	],
	"./v299/tab-slide-before.gif": [
		"./code/client/static/images/patch_notes/v299/tab-slide-before.gif",
		"shared"
	],
	"./v299/tile_highlights_after.png": [
		"./code/client/static/images/patch_notes/v299/tile_highlights_after.png",
		"shared"
	],
	"./v299/tile_highlights_before.png": [
		"./code/client/static/images/patch_notes/v299/tile_highlights_before.png",
		"shared"
	],
	"./v299/username-after.png": [
		"./code/client/static/images/patch_notes/v299/username-after.png",
		"shared"
	],
	"./v299/username-before.png": [
		"./code/client/static/images/patch_notes/v299/username-before.png",
		"shared"
	],
	"./v299/web-more-page-after.png": [
		"./code/client/static/images/patch_notes/v299/web-more-page-after.png",
		"shared"
	],
	"./v299/web-more-page-before.png": [
		"./code/client/static/images/patch_notes/v299/web-more-page-before.png",
		"shared"
	],
	"./v300/hard-bot-after.png": [
		"./code/client/static/images/patch_notes/v300/hard-bot-after.png",
		"shared"
	],
	"./v300/hard-bot-before.png": [
		"./code/client/static/images/patch_notes/v300/hard-bot-before.png",
		"shared"
	],
	"./v300/new-web-sidebar-after.png": [
		"./code/client/static/images/patch_notes/v300/new-web-sidebar-after.png",
		"shared"
	],
	"./v300/new-web-sidebar-before.png": [
		"./code/client/static/images/patch_notes/v300/new-web-sidebar-before.png",
		"shared"
	],
	"./v301/coins-navbar-after.png": [
		"./code/client/static/images/patch_notes/v301/coins-navbar-after.png",
		"shared"
	],
	"./v301/coins-navbar-before.png": [
		"./code/client/static/images/patch_notes/v301/coins-navbar-before.png",
		"shared"
	],
	"./v301/rushplayer-after.png": [
		"./code/client/static/images/patch_notes/v301/rushplayer-after.png",
		"shared"
	],
	"./v301/rushplayer-before.png": [
		"./code/client/static/images/patch_notes/v301/rushplayer-before.png",
		"shared"
	],
	"./v301/rushplayerweb-after.png": [
		"./code/client/static/images/patch_notes/v301/rushplayerweb-after.png",
		"shared"
	],
	"./v301/rushplayerweb-before.png": [
		"./code/client/static/images/patch_notes/v301/rushplayerweb-before.png",
		"shared"
	],
	"./v302/rush-endturnicon-after.png": [
		"./code/client/static/images/patch_notes/v302/rush-endturnicon-after.png",
		"shared"
	],
	"./v302/rush-endturnicon-before.png": [
		"./code/client/static/images/patch_notes/v302/rush-endturnicon-before.png",
		"shared"
	],
	"./v302/rushrobber-after.png": [
		"./code/client/static/images/patch_notes/v302/rushrobber-after.png",
		"shared"
	],
	"./v302/rushrobber-before.png": [
		"./code/client/static/images/patch_notes/v302/rushrobber-before.png",
		"shared"
	],
	"./v302/rushtooltip-after.png": [
		"./code/client/static/images/patch_notes/v302/rushtooltip-after.png",
		"shared"
	],
	"./v302/rushtooltip-before.png": [
		"./code/client/static/images/patch_notes/v302/rushtooltip-before.png",
		"shared"
	],
	"./v302/suggestions-after.png": [
		"./code/client/static/images/patch_notes/v302/suggestions-after.png",
		"shared"
	],
	"./v304/homepage-bot-cards-after.png": [
		"./code/client/static/images/patch_notes/v304/homepage-bot-cards-after.png",
		"shared"
	],
	"./v304/homepage-bot-cards-before.png": [
		"./code/client/static/images/patch_notes/v304/homepage-bot-cards-before.png",
		"shared"
	],
	"./v304/roompage-bot-selector-after.png": [
		"./code/client/static/images/patch_notes/v304/roompage-bot-selector-after.png",
		"shared"
	],
	"./v304/roompage-bot-selector-before.png": [
		"./code/client/static/images/patch_notes/v304/roompage-bot-selector-before.png",
		"shared"
	],
	"./v305/fix-overflowing-bot-selector-after.png": [
		"./code/client/static/images/patch_notes/v305/fix-overflowing-bot-selector-after.png",
		"shared"
	],
	"./v305/fix-overflowing-bot-selector-before.png": [
		"./code/client/static/images/patch_notes/v305/fix-overflowing-bot-selector-before.png",
		"shared"
	],
	"./v305/room-bot-selector-after.png": [
		"./code/client/static/images/patch_notes/v305/room-bot-selector-after.png",
		"shared"
	],
	"./v305/room-bot-selector-before.png": [
		"./code/client/static/images/patch_notes/v305/room-bot-selector-before.png",
		"shared"
	],
	"./v305/wrong-user-highlighted-after.jpg": [
		"./code/client/static/images/patch_notes/v305/wrong-user-highlighted-after.jpg",
		"shared"
	],
	"./v305/wrong-user-highlighted-before.jpg": [
		"./code/client/static/images/patch_notes/v305/wrong-user-highlighted-before.jpg",
		"shared"
	],
	"./v306/map-zoom-after.png": [
		"./code/client/static/images/patch_notes/v306/map-zoom-after.png",
		"shared"
	],
	"./v306/map-zoom-before.png": [
		"./code/client/static/images/patch_notes/v306/map-zoom-before.png",
		"shared"
	],
	"./v307/rush-stats-after.png": [
		"./code/client/static/images/patch_notes/v307/rush-stats-after.png",
		"shared"
	],
	"./v308/build-placement-circles-after.png": [
		"./code/client/static/images/patch_notes/v308/build-placement-circles-after.png",
		"shared"
	],
	"./v308/build-placement-circles-before.png": [
		"./code/client/static/images/patch_notes/v308/build-placement-circles-before.png",
		"shared"
	],
	"./v309/game-settings-design-after.png": [
		"./code/client/static/images/patch_notes/v309/game-settings-design-after.png",
		"shared"
	],
	"./v309/game-settings-design-before.png": [
		"./code/client/static/images/patch_notes/v309/game-settings-design-before.png",
		"shared"
	],
	"./v309/knight-upgrade-zero-badge-after.png": [
		"./code/client/static/images/patch_notes/v309/knight-upgrade-zero-badge-after.png",
		"shared"
	],
	"./v309/knight-upgrade-zero-badge-before.png": [
		"./code/client/static/images/patch_notes/v309/knight-upgrade-zero-badge-before.png",
		"shared"
	],
	"./v310/mobile-chat-log-buttons-after.png": [
		"./code/client/static/images/patch_notes/v310/mobile-chat-log-buttons-after.png",
		"shared"
	],
	"./v310/mobile-chat-log-buttons-before.png": [
		"./code/client/static/images/patch_notes/v310/mobile-chat-log-buttons-before.png",
		"shared"
	],
	"./v310/vote-modal-design-after.png": [
		"./code/client/static/images/patch_notes/v310/vote-modal-design-after.png",
		"shared"
	],
	"./v310/vote-modal-design-before.png": [
		"./code/client/static/images/patch_notes/v310/vote-modal-design-before.png",
		"shared"
	],
	"./v312/port-trade-text-after.png": [
		"./code/client/static/images/patch_notes/v312/port-trade-text-after.png",
		"shared"
	],
	"./v312/port-trade-text-before.png": [
		"./code/client/static/images/patch_notes/v312/port-trade-text-before.png",
		"shared"
	],
	"./v312/trade-offers-after.png": [
		"./code/client/static/images/patch_notes/v312/trade-offers-after.png",
		"shared"
	],
	"./v312/trade-offers-before.png": [
		"./code/client/static/images/patch_notes/v312/trade-offers-before.png",
		"shared"
	],
	"./v314/insufficient-resources-log-after.png": [
		"./code/client/static/images/patch_notes/v314/insufficient-resources-log-after.png",
		"shared"
	],
	"./v314/insufficient-resources-log-before.png": [
		"./code/client/static/images/patch_notes/v314/insufficient-resources-log-before.png",
		"shared"
	],
	"./v314/robber-vp-after.png": [
		"./code/client/static/images/patch_notes/v314/robber-vp-after.png",
		"shared"
	],
	"./v314/robber-vp-before.png": [
		"./code/client/static/images/patch_notes/v314/robber-vp-before.png",
		"shared"
	],
	"./v314/vote-popup-after.png": [
		"./code/client/static/images/patch_notes/v314/vote-popup-after.png",
		"shared"
	],
	"./v314/vote-popup-before.png": [
		"./code/client/static/images/patch_notes/v314/vote-popup-before.png",
		"shared"
	],
	"./v315/floating-text-overflow-after.png": [
		"./code/client/static/images/patch_notes/v315/floating-text-overflow-after.png",
		"shared"
	],
	"./v315/floating-text-overflow-before.png": [
		"./code/client/static/images/patch_notes/v315/floating-text-overflow-before.png",
		"shared"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./code/client/static/images/patch_notes lazy recursive ^\\.\\/.*\\/.*\\..*$";
module.exports = webpackAsyncContext;